module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-16-902b3b4c0f6bb45fa3b97b800c8e2962.jpg";